/**
 * Copyright (c) 2018 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import {
  ADD_COMMENT,
  ADD_DOCUMENT,
  CANCEL_BTN,
  CONFIRM_REPRESENTATION_CHANGE_ACK,
  CONFIRM_REPRESENTATION_CHANGE_WARNING,
  NO_CONTENT_FOUND,
  NO_RESULTS_FOUND,
  ONE_PARENT_GUARDIAN,
  REASON_ADD,
  SEARCH_DOCUMENT,
  SELECT_SIGNATURES_LABEL,
  SIGNATURE_LAR,
  SIGNATURE_PARENT_GUARDIAN,
  SIGNATURE_PARTICIPANT,
  SIGNATURE_WITNESS,
  TWO_PARENTS_GUARDIANS
} from '../../const';
import { Checkbox, ControlLabel, FormControl, FormGroup, InputGroup, Panel, PanelGroup, Radio } from 'react-bootstrap';
import { Button } from 'tc-client-common';
import Loading from '../loading/loading.component';
import { LANGUAGES as languages } from '../../constants/languages';
import Notification from '../common/notification/notification.component';
import DocumentsService from './documents.service';

class AddDocumentComponent extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleSelect = this.handleSelect.bind(this);
    this.changeReasonHandler = this.changeReasonHandler.bind(this);
    this.componentIsMounted = false;

    const consenting = this.props.consenting;
    this.state = {
      activeKey: 0,
      reason: '',
      availableDocuments: this.props.availableDocuments,
      filterString: '',
      participantCheckbox: consenting ? !consenting.lar && consenting.parents === 0 : false,
      larCheckbox: consenting ? consenting.lar : false,
      parentCheckbox: consenting ? consenting.parents > 0 : false,
      parentCount: consenting && consenting.parents > 0 ? consenting.parents : 1,
      witnessCheckbox: consenting ? consenting.witness : false,
      loading: false,
      confirmAcknowledged: false
    };
  }

  componentDidMount() {
    this.componentIsMounted = true;
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.consenting && this.props.consenting) {
      const consenting = this.props.consenting;
      this.setState({
        participantCheckbox: !consenting.lar && consenting.parents === 0,
        larCheckbox: consenting.lar,
        parentCheckbox: consenting.parents > 0,
        parentCount: consenting.parents > 0 ? consenting.parents : 1,
        witnessCheckbox: consenting.witness
      });
    }
  }

  componentWillUnmount() {
    this.componentIsMounted = false;
  }

  hasConsenting = () => this.props.consenting !== null && this.props.consenting !== undefined;

  getSelectedDocument = () => {
    const docs = this.state.filterString.length > 0 ? this.state.availableDocuments : this.props.availableDocuments;
    if (!docs || this.state.activeKey < 1) return null;
    return docs[this.state.activeKey - 1] || null;
  };

  handleSelect(activeKey) {
    const consenting = this.props.consenting;
    const docs = this.state.filterString.length > 0 ? this.state.availableDocuments : this.props.availableDocuments;
    const doc = docs ? docs[activeKey - 1] : null;
    const config = doc && doc.configurations ? doc.configurations : {};
    this.setState({
      activeKey,
      reason: '',
      participantCheckbox: consenting ? !consenting.lar && consenting.parents === 0 : false,
      larCheckbox: config.larEnabled && consenting ? consenting.lar : false,
      parentCheckbox: config.minorParticipantAllowed && consenting ? consenting.parents > 0 : false,
      parentCount: consenting && consenting.parents > 0 ? consenting.parents : 1,
      witnessCheckbox: config.witnessEnabled && consenting ? consenting.witness : false,
      confirmAcknowledged: false
    });
  }

  changeReasonHandler(event) {
    this.setState({ reason: event.target.value });
  }

  participantCheckboxChange = (e) => {
    this.setState({ participantCheckbox: e.target.checked, confirmAcknowledged: false });
  };

  larCheckboxChange = (e) => {
    const { checked } = e.target;
    if (checked) {
      this.setState({ larCheckbox: true, parentCheckbox: false, confirmAcknowledged: false });
    } else {
      this.setState({ larCheckbox: false, confirmAcknowledged: false });
    }
  };

  parentCheckboxChange = (e) => {
    const { checked } = e.target;
    if (checked) {
      this.setState({ parentCheckbox: true, parentCount: 1, larCheckbox: false, confirmAcknowledged: false });
    } else {
      this.setState({ parentCheckbox: false, parentCount: 1, confirmAcknowledged: false });
    }
  };

  parentCountChange = (e) => {
    this.setState({ parentCount: parseInt(e.target.value, 10) });
  };

  witnessCheckboxChange = (e) => {
    this.setState({ witnessCheckbox: e.target.checked });
  };

  confirmAckChange = (e) => {
    this.setState({ confirmAcknowledged: e.target.checked });
  };

  hasRepresentationChanged = () => {
    const consenting = this.props.consenting;
    if (!consenting) return false;
    const prevLar = consenting.lar;
    const prevParent = consenting.parents > 0;
    const prevParticipant = !prevLar && !prevParent;
    return (
      this.state.larCheckbox !== prevLar ||
      this.state.parentCheckbox !== prevParent ||
      this.state.participantCheckbox !== prevParticipant
    );
  };

  getPreviousRepresentationLabel = () => {
    const consenting = this.props.consenting;
    if (!consenting) return '';
    if (consenting.lar) return SIGNATURE_LAR;
    if (consenting.parents > 0) return SIGNATURE_PARENT_GUARDIAN;
    return SIGNATURE_PARTICIPANT;
  };

  renderSignatoryCheckboxes = (configurations) => {
    const config = configurations || {};
    return (
      <div className="minorRepresentationCheckboxes">
        <p>{SELECT_SIGNATURES_LABEL}</p>
        <Checkbox
          checked={this.state.participantCheckbox}
          onChange={this.participantCheckboxChange}
          className="customCheckbox"
        >
          <p>{SIGNATURE_PARTICIPANT}</p>
        </Checkbox>
        {config.larEnabled ? (
          <Checkbox
            checked={this.state.larCheckbox}
            onChange={this.larCheckboxChange}
            disabled={this.state.parentCheckbox}
            className="customCheckbox"
          >
            <p>{SIGNATURE_LAR}</p>
          </Checkbox>
        ) : null}
        {config.minorParticipantAllowed ? (
          <div>
            <Checkbox
              checked={this.state.parentCheckbox}
              onChange={this.parentCheckboxChange}
              disabled={this.state.larCheckbox}
              className="customCheckbox"
            >
              <p>{SIGNATURE_PARENT_GUARDIAN}</p>
            </Checkbox>
            {this.state.parentCheckbox && (
              <div className="parent-count-selection" style={{ marginLeft: '25px' }}>
                <Radio
                  name="parentCount"
                  value={1}
                  checked={this.state.parentCount === 1}
                  onChange={this.parentCountChange}
                  className="customCheckbox"
                >
                  <p>{ONE_PARENT_GUARDIAN}</p>
                </Radio>
                <Radio
                  name="parentCount"
                  value={2}
                  checked={this.state.parentCount === 2}
                  onChange={this.parentCountChange}
                  className="customCheckbox"
                >
                  <p>{TWO_PARENTS_GUARDIANS}</p>
                </Radio>
              </div>
            )}
          </div>
        ) : null}
        {config.witnessEnabled ? (
          <Checkbox
            checked={this.state.witnessCheckbox}
            onChange={this.witnessCheckboxChange}
            className="customCheckbox"
          >
            <p>{SIGNATURE_WITNESS}</p>
          </Checkbox>
        ) : null}
        {this.hasRepresentationChanged() && (
          <div className="representation-change-warning">
            <p>
              {CONFIRM_REPRESENTATION_CHANGE_WARNING} (was: <strong>{this.getPreviousRepresentationLabel()}</strong>).
            </p>
            <Checkbox
              checked={this.state.confirmAcknowledged}
              onChange={this.confirmAckChange}
              className="customCheckbox"
              id="confirm-representation-ack"
            >
              <p>{CONFIRM_REPRESENTATION_CHANGE_ACK}</p>
            </Checkbox>
          </div>
        )}
      </div>
    );
  };

  listAvailableDocuments = () => {
    let docs = [],
      key = 1,
      data = this.state.availableDocuments;
    if (this.state.filterString.length < 1) {
      data = this.props.availableDocuments;
    }

    const selectedIcon = <i className="material-icons">check_circle</i>;
    const documentIcon = <i className="material-icons">insert_drive_file</i>;
    for (let d of data) {
      const icon = key === this.state.activeKey ? selectedIcon : documentIcon;
      const style = key === this.state.activeKey ? 'primary' : '';
      let panel = (
        <Panel eventKey={key} key={`${d.documentId}-${d.documentVersion}`} bsStyle={style}>
          <Panel.Heading>
            <Panel.Title toggle>
              <div className="document-icon">{icon}</div>
              <div>{DocumentsService.buildDocumentFullName(d.name, d.documentVersion)}</div>
              <div className="config-label">{DocumentsService.getLabelForDocumentConfiguration(d.configurations)}</div>
            </Panel.Title>
          </Panel.Heading>
          <Panel.Body collapsible>
            <FormGroup controlId="reason">
              <ControlLabel>
                {REASON_ADD} <span>*</span>
              </ControlLabel>
              <FormControl
                componentClass="textarea"
                id="reason"
                value={this.state.reason}
                autoFocus
                onChange={this.changeReasonHandler}
                placeholder={ADD_COMMENT}
                required
              />
            </FormGroup>
            {this.hasConsenting() ? this.renderSignatoryCheckboxes(d.configurations) : null}
          </Panel.Body>
        </Panel>
      );
      docs.push(panel);
      key++;
    }
    return docs;
  };

  moveCaretAtEnd = (e) => {
    let temp_value = e.target.value;
    e.target.value = '';
    e.target.value = temp_value;
  };

  handleFilter = (e) => {
    this.setState({ filterString: e.target.value });
    this.setState({ availableDocuments: this.props.availableDocuments.filter((doc) => this.filter(e, doc)) });
    this.setState({ activeKey: '1' });
  };

  filter = (e, doc) => {
    const value = e.target.value.toLowerCase();
    return (
      doc.name.toLowerCase().includes(value) ||
      String(doc.documentVersion).includes(value) ||
      (languages[doc.language]
        ? languages[doc.language].toLowerCase().includes(value)
        : doc.language.toLowerCase().includes(value))
    );
  };

  handleAddClick = () => {
    this.add();
  };

  add = () => {
    this.setState({ loading: true });

    let doc;
    if (!this.state.availableDocuments) {
      doc = this.props.availableDocuments[this.state.activeKey - 1];
    } else {
      doc = this.state.availableDocuments[this.state.activeKey - 1];
    }

    const payload = {
      reason: this.state.reason,
      documentId: doc.documentId,
      investigatorId: this.props.userId,
      lar: this.state.larCheckbox,
      witness: this.state.witnessCheckbox,
      minor: this.props.consenting ? this.props.consenting.minor : false,
      parents: this.state.parentCheckbox ? this.state.parentCount : 0,
      needsWitnessSignature: this.state.witnessCheckbox,
      needsParentsSignature: this.state.parentCheckbox,
      needsParticipantSignature: this.state.participantCheckbox,
      hasAuthority: true
    };

    let id = doc.gid.slice(doc.gid.indexOf('|') + 1);

    this.props
      .add(this.props.participant.gid, id, 'ADD', payload)
      .then(() => {
        if (this.componentIsMounted) {
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        if (this.componentIsMounted) {
          console.error('Error adding document:', error);
          this.setState({ loading: false });
        }
      });
  };

  isDisabled = () => {
    if (this.state.loading) return true;

    const noDocSelected = this.state.activeKey < 1;
    const noReason = this.state.reason.length < 1;

    if (noDocSelected || noReason) return true;

    if (this.hasConsenting()) {
      const doc = this.getSelectedDocument();
      const config = doc && doc.configurations ? doc.configurations : {};
      const larValid = config.larEnabled ? this.state.larCheckbox : false;
      const parentValid = config.minorParticipantAllowed ? this.state.parentCheckbox : false;
      const hasPrimarySignatory = this.state.participantCheckbox || larValid || parentValid;
      if (!hasPrimarySignatory) return true;

      if (this.hasRepresentationChanged() && !this.state.confirmAcknowledged) return true;
    }

    return false;
  };

  render() {
    let body,
      error,
      documents = '';
    let isDisabled = this.isDisabled();
    if (this.props.availableDocumentsError) {
      error = <Notification type="error" data={this.props.availableDocumentsError} />;
    }
    if (this.props.errorFetchConsenting) {
      error = <Notification type="error" data={this.props.errorFetchConsenting} />;
    }
    if (this.props.isFetchingAvailableDocuments || this.props.isFetchingConsenting) {
      body = <Loading />;
    } else {
      if (!this.props.availableDocuments || this.props.availableDocuments.length < 1) {
        body = <Notification type="info" data={NO_CONTENT_FOUND} />;
      } else {
        if (this.state.filterString.length > 0 && this.state.availableDocuments.length < 1) {
          documents = <Notification type="info" data={NO_RESULTS_FOUND} />;
        } else {
          documents = (
            <PanelGroup
              accordion
              id="available-documents"
              activeKey={this.state.activeKey}
              onSelect={this.handleSelect}
            >
              {this.listAvailableDocuments()}
            </PanelGroup>
          );
        }
        body = (
          <div>
            {error}
            <FormGroup>
              <InputGroup>
                <FormControl
                  id="documents-filter"
                  type="text"
                  value={this.state.filterString}
                  placeholder={SEARCH_DOCUMENT}
                  onChange={this.handleFilter}
                />
                <InputGroup.Addon>
                  <i className="material-icons">search</i>
                </InputGroup.Addon>
              </InputGroup>
            </FormGroup>
            <div id="wrapper-add-document">
              <div id="scrollable-add-document">{documents}</div>
            </div>
          </div>
        );
      }
    }

    return (
      <div id="add-document-component">
        {body}
        <div className="edit-modal-footer">
          <hr className="edit-modal-divider" />
          <Button
            id="add-document-cancel-button"
            theme="default large-button"
            type="reset"
            handleClick={this.props.close}
            label={CANCEL_BTN}
          />
          <Button
            id="add-document-button"
            disabled={isDisabled}
            theme="active large-button"
            type="submit"
            handleClick={this.handleAddClick}
            label={ADD_DOCUMENT}
          />
        </div>
      </div>
    );
  }
}

export default AddDocumentComponent;
